
import { defineComponent, reactive, toRefs, watch, computed } from 'vue';
import IconEye from '../assets/svg/password_show.svg?raw';
import IconEyeClosed from '../assets/svg/password_hide.svg?raw';

interface Data {
  showPassword: boolean,
  internalValue?: string,
}

const KoddeinFormPassword = defineComponent({
  name: "KoddeinFormPassword",
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: undefined,
    },
    autocomplete: {
      type: String,
      default: undefined,
    },
    /** input typ */
    type: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: undefined,
    },
    /** input value */
    value: {
      type: String,
      default: undefined,
    },
    /** input error */
    error: {
      type: String,
      default: undefined,
    },
    /** aria-label text */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },
  emits: ['inputChange', 'onFocus', 'onBlur'],
  setup(props, { emit }) {
    const data: Data = reactive(
      {
        showPassword: false,
        internalValue: undefined,
      }
    );

    // change input type to text or not - will show password
    const inputType = computed(() => {
      return data.showPassword ? 'text' : props.type;
    });

    const toggleShow = () => {
      data.showPassword = !data.showPassword;
    };

    /**
     * Watch value, on value update -> set internal value
     */
    watch(
      () => props.value,
      (value) => {
        data.internalValue = value;
      },
      { immediate: true }
    )

    /**
     * Watch internal value, on value update -> send value to parent
     */
    watch(
      () => data.internalValue,
      (value) => {
        if (value === props.value) return;
        emit('inputChange', value);
      },
      // { immediate:true }
    )

    const focus = () => {
      emit('onFocus');
    }
    const blur = () => {
      emit('onBlur');
    }

    return {
      ...toRefs(data), //data
      IconEye,
      IconEyeClosed,
      inputType,
      toggleShow,
      isFocus: focus,
      isBlur: blur,
    };
  },
});
export default KoddeinFormPassword
